<template>
	<tfoot v-if="length == 0">
		<tr>
			<th colspan="40" class="text-center">{{ _traducao('global', 'nenhumRegistroEncontrado') }}.</th>
		</tr>
	</tfoot>
</template>

<script>
export default {
	props: {
		length: {
			type: [Number, Function],
			default: 0,
			required: true
		}
	}
}
</script>
